import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, documentSearchTypes} from '../../util/uiconstants';

export const getEntityDocuments = (engagementId, entityTypeId, documentCategoryName) => {
	const endpointURL =
		Env.getBaseURL(serviceURL, engagementId) +
		`Documents?documentTypeIdList=${entityTypeId}` +
		`&includeDocumentList=true` +
		`&includeApprovals=true` +
		`&includeClientApprovals=true` +
		`&includeReviewNotes=true` +
		`&includeRelatedEntities=true` +
		`&filteredEntityType=${documentSearchTypes.engagement}` +
		`&pageSize=-1` +
		`${documentCategoryName ? `&documentCategoryName=` + documentCategoryName : ''}`;

	return {
		type: types.GET_ENTITY_DOCUMENTS,
		resolve: true,
		meta: {
			api: {
				url: endpointURL,
				method: 'GET'
			}
		}
	};
};

export const renameDocument = (documentId, newDocumentName) => {
	return {
		type: types.SET_ENTITY_DOCUMENT_NAME,
		documentId: documentId,
		newDocumentName: newDocumentName
	};
};

export const addEntityDocumentSignOff = (documentId, signOff) => {
	return {
		type: types.ADD_ENTITY_DOCUMENT_SIGNOFF,
		documentId: documentId,
		documentSignoff: signOff
	};
};

export const removeEntityDocumentSignOff = (documentId, approvalId) => {
	return {
		type: types.REMOVE_ENTITY_DOCUMENT_SIGNOFF,
		documentId: documentId,
		approvalId: approvalId
	};
};

export const clearEntityDocuments = () => {
	return {
		type: types.CLEAR_ENTITY_DOCUMENTS
	};
};
